import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@common/global';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MemberService } from '@services/member.service';
import { Router, ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.sass']
})
export class ForgotPasswordComponent implements OnInit {

  forgotForm: FormGroup;
  btn_process = false;
  captchaName = '';
  error: any = { "email": "", "captchaToken": "" };
  constructor(private route: ActivatedRoute,private _memberService: MemberService, private fb: FormBuilder, private router: Router, public _global: GlobalService) {
    this.forgotForm = this.fb.group({
      email: [],
      captchaToken:[]
    });
    this.captchaName = this._global.randomAlphaNumeric(8);
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      console.log("Route Params", params);
      if (params['email']) {
        this.forgotForm.get("email").setValue(params['email']);
      }
    });
  }
  public resetPassword() {
    this.error = { "email": "", "captchaToken": "" };
    this.btn_process = true;
    let r = this.forgotForm.value;
    r = this._global.paramsRemoveNull(r);
    r['recaptcha_challenge_field']= this.captchaName,
    this._memberService.passwordResetEmail(r).subscribe(
      data => {
        let response = this._global.getVal(data, 'response', '');
        if (!_.isEmpty(response)) {
          this._global.showMessage({ "type": "success", "message": ' You should be receiving email ' + r["email"], "title": "" });
          this.router.navigate(['']);
        }
        else {
          this.btn_process = false;
          for (let key in data["errors"]) {
            this.error[key] = data["errors"][key]["message"];
          }
        }
      },
      error => {
        console.log("Validate Error", error);
      });
  }
}
